const plausibleConfig = {
	externalId: 'oblivio-plausible-external',
	inlineId: 'oblivio-plausible-inline',
	bootstrapId: 'oblivio-plausible-bootstrap',
	scriptUrl: 'https://analytics.oblivio.app/js/pa-z9cwDkCqp5DXlpoepbcTV.js',
	inlineSnippet:
		'window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};\nplausible.init()',
}

export function setCheckboxState(checkbox, isEnabled) {
	const checkedValue = Boolean(isEnabled)
	checkbox.checked = checkedValue
}

export function togglePlausibleScript(isEnabled) {
	const shouldEnable = Boolean(isEnabled)
	if (shouldEnable) {
		enablePlausible()
	} else {
		disablePlausible()
	}
}

function enablePlausible() {
	const hasExternal = Boolean(getExternalScript())
	const hasInline = Boolean(getInlineScript())
	if (hasExternal && hasInline) return

	removeExternalScript()
	removeInlineScript()
	removeBootstrapScript()

	if (!hasExternal) appendExternalScript()
	if (!hasInline) appendInlineScript()
}

function disablePlausible() {
	removeExternalScript()
	removeInlineScript()
	removeBootstrapScript()
	window.plausible = function () {}
}

function getExternalScript() {
	return document.getElementById(plausibleConfig.externalId)
}

function getInlineScript() {
	return document.getElementById(plausibleConfig.inlineId)
}

function getBootstrapScript() {
	return document.getElementById(plausibleConfig.bootstrapId)
}

function appendExternalScript() {
	const script = document.createElement('script')
	script.async = true
	script.id = plausibleConfig.externalId
	script.src = plausibleConfig.scriptUrl
	document.head.appendChild(script)
}

function appendInlineScript() {
	const script = document.createElement('script')
	script.id = plausibleConfig.inlineId
	script.text = plausibleConfig.inlineSnippet
	document.head.appendChild(script)
}

function removeExternalScript() {
	const scripts = getHeadScripts().filter((item) => {
		const src = item.src || ''
		const hasMatchingSrc = src.includes('analytics.oblivio.app/js/pa-')
		const hasLegacyId = item.id === 'oblivio-plausible'
		const hasKnownId = item.id === plausibleConfig.externalId
		return hasMatchingSrc || hasLegacyId || hasKnownId
	})
	scripts.forEach((item) => item.remove())
}

function removeInlineScript() {
	const scripts = getHeadScripts().filter((item) => {
		if (item.src) return false
		const content = (item.textContent || '').replace(/\s+/g, '')
		const target = plausibleConfig.inlineSnippet.replace(/\s+/g, '')
		const hasMatchingSnippet = content === target
		const hasPlausibleInit =
			content.includes('window.plausible=window.plausible') ||
			content.includes('plausible.init')
		const hasKnownId = item.id === plausibleConfig.inlineId
		return hasKnownId || hasMatchingSnippet || hasPlausibleInit
	})
	scripts.forEach((item) => item.remove())
}

function removeBootstrapScript() {
	const bootstrapScript = getBootstrapScript()
	if (bootstrapScript) bootstrapScript.remove()
}

function getHeadScripts() {
	return Array.from(document.head?.querySelectorAll('script') || [])
}
